import React, {memo, useCallback, useState} from 'react';
import './index.scss';

import {onClickHandler} from '../../utils/onclick';
import iconCancel from '../../assets/images/icons/media/cancel.png';
import iconSave from '../../assets/images/icons/media/save.png';
import iconMedia from '../../assets/images/icons/media/other.png';
import {useDispatch, useSelector} from 'react-redux';
import {useFilterSelector} from '../../hooks/filter-selector';
import {MEDIA_TYPE_ID_AIR_CONDITIONER, MediaModel} from '../../types/control';
import {setSTPUIMediaScreenAction} from '../../store/ui/actions';
import {useRPC} from '../../hooks/rpc';
import {useMessage} from '../../hooks/message';
import {mediaIcons} from '../MediaListScreen';
import {useLocalization} from "../../hooks/localization";

export const StpUIMediaScreen = memo(function StpUIMediaScreen() {
        const {t} = useLocalization();
        const dispatch = useDispatch();
        const [rpc] = useRPC();
        const {failure} = useMessage();
        const selectedStpUIEntity = useSelector(state => state.ui.stpUIMediaScreen.selectedMedia);
        const mediaList = useFilterSelector(state => state.control.mediaList,
            (m) => selectedStpUIEntity.type === 'air' ? m.type_id === MEDIA_TYPE_ID_AIR_CONDITIONER :
                m.type_id !== MEDIA_TYPE_ID_AIR_CONDITIONER);
        const [selectedMedia, setSelectedMedia] = useState<MediaModel>(mediaList.find(m => m.id === selectedStpUIEntity.relational_id) || null);

        const close = useCallback(() => {
            dispatch(setSTPUIMediaScreenAction(null));
        }, [dispatch]);

        const save = useCallback(() => {
            rpc.updateSTPUI({
                ...selectedStpUIEntity,
                relational_id: selectedMedia?.id,
            })
                .then(close)
                .catch(failure);
        }, [close, failure, rpc, selectedMedia, selectedStpUIEntity]);

        return (
            <div className='content-page stp-media-screen'>
                <div className='content-divider top'>
                    <div className='content-divider left'>
                        <div className='content-top'>
                            <div className='content-wrapper'>
                                <div className='action-row'>
                                    <div className='action' {...onClickHandler(close)}>
                                        <img src={iconCancel} alt=''/>
                                        <span>{t('CANCEL')}</span>
                                    </div>
                                    <span>{selectedStpUIEntity.display_name}</span>
                                    <div className='action' {...onClickHandler(save)}>
                                        <img src={iconSave} alt=''/>
                                        <span>{t('SAVE')}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='content-divider right'>
                        <div
                            className='content-wrapper' {...onClickHandler(() => setSelectedMedia(null))}>
                            <div className='left-container'>
                                <img src={iconMedia} alt=''/>
                                <span>{t('NONE')}</span>
                            </div>
                            <div className={'check-box' + (selectedMedia === null ? ' checked' : '')}/>
                        </div>
                        {
                            mediaList.map(media => (
                                <div
                                    className='content-wrapper' {...onClickHandler(() => setSelectedMedia(media))}
                                    key={`media_${media.id}`}>
                                    <div className='left-container'>
                                        <img src={mediaIcons[media.icon]} alt=''/>
                                        <span>{media.name}</span>
                                    </div>
                                    <div className={'check-box' + (selectedMedia === media ? ' checked' : '')}/>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        );
    },
);
